module.exports = __webpack_public_path__ + "static/media/Subtract.4cdf18e5.svg";